import { TenantEntity } from '@/class/model/TenantEntity'

/**
 * 发票号管理-使用记录
 */
export class RecipientsInvoiceRecords extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }

  get invoiceType() {
    return this._data.invoiceType
  }
  set invoiceType(invoiceType) {
    this._data.invoiceType = invoiceType
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity
  }
  get recipienter() {
    return this._data.recipienter
  }
  set recipienter(recipienter) {
    this._data.recipienter = recipienter
  }
  get recipientingDate() {
    return this._data.recipientingDate
  }
  set recipientingDate(recipientingDate) {
    this._data.recipientingDate = recipientingDate
  }
  get branchId() {
    return this._data.branchId
  }
  set branchId(branchId) {
    this._data.branchId = branchId
  }
}
